import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, inject } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import { FilterService, ReferralService } from '@ninety/platform/services';
import { FeatureFlagFacade, FeatureFlagKeys, selectIsTrialSubscription } from '@ninety/platform/state';

declare global {
  interface Window {
    impactToken: any;
  }
}

@Component({
  selector: 'ninety-referral',
  standalone: true,
  imports: [LetDirective],
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReferralComponent implements OnInit, OnDestroy {
  private referralService = inject(ReferralService);
  private filterService = inject(FilterService);
  private featureFlags = inject(FeatureFlagFacade);
  private store = inject(Store);

  protected impactToken: string | null = null;
  protected isWidgetReady = false;
  protected readonly enableReferralProgram$ = this.featureFlags.getFlag(FeatureFlagKeys.referralProgram);
  protected readonly isTrialSubscription$ = this.store.select(selectIsTrialSubscription);
  private destroy$ = new Subject<void>();

  constructor() {
    this.filterService.setOptions({ filtersToolbar: false });
  }

  ngOnInit() {
    this.referralService
      .getReferralJwt()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.impactToken = res;
        window.impactToken = this.impactToken;
        this.waitForWidget().then(() => {
          this.isWidgetReady = true;
        });
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
  async waitForWidget() {
    while (!customElements.get('impact-embed')) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }
}
